import EditorButton from "./components/EditorButton";
import Divider from "./components/Divider";
import TextOptions from "./module/TextOptions";
import ImageAndLink from "./module/ImageAndLink";
import TextAlignOptions from "./module/TextAlignOptions";
import FontFamilySelector from "./module/FontFamilySelector";
import {
  Undo,
  Redo,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Code,
  List,
  ListOrdered,
  ListTodo,
  Quote,
  Minus,
} from "lucide-react";

const Toolbar = ({ editor, fontFamilies = [] }) => {
  return (
    <div className="flex flex-wrap justify-center gap-1 pb-2">
      {/* Undo/Redo */}
      <EditorButton
        onClick={() => editor.chain().focus().undo().run()}
        className={!editor.can().undo() ? "opacity-30" : "opacity-100"}
        title="Undo">
        <Undo size={16} />
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().redo().run()}
        className={!editor.can().redo() ? "opacity-30" : "opacity-100"}
        title="Redo">
        <Redo size={16} />
      </EditorButton>
      <Divider />
      <div className="w-32">
        <TextOptions editor={editor} />
      </div>
      <FontFamilySelector editor={editor} fontFamilies={fontFamilies} />
      <Divider />
      {/* Basic Formatting */}
      <EditorButton
        onClick={() => editor.chain().focus().toggleBold().run()}
        isActive={editor.isActive("bold")}
        title="Bold">
        <Bold size={16} />
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleItalic().run()}
        isActive={editor.isActive("italic")}
        title="Italic">
        <Italic size={16} />
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        isActive={editor.isActive("underline")}
        title="Underline">
        <Underline size={16} />
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleStrike().run()}
        isActive={editor.isActive("strike")}
        title="Strike">
        <Strikethrough size={16} />
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleCode().run()}
        isActive={editor.isActive("code")}
        title="Code">
        <Code size={16} />
      </EditorButton>
      <Divider />
      <ImageAndLink editor={editor} />
      <Divider />
      {/* Lists */}
      <EditorButton
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        isActive={editor.isActive("bulletList")}
        title="Bullet List">
        <List size={16} />
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        isActive={editor.isActive("orderedList")}
        title="Ordered List">
        <ListOrdered size={16} />
      </EditorButton>
      <EditorButton
        onClick={() => editor.chain().focus().toggleTaskList().run()}
        isActive={editor.isActive("taskList")}
        title="Task List">
        <ListTodo size={16} />
      </EditorButton>
      <Divider />

      {/* Block Elements */}
      <EditorButton
        onClick={() => editor.chain().focus().toggleBlockquote().run()}
        isActive={editor.isActive("blockquote")}
        title="Blockquote">
        <Quote size={16} />
      </EditorButton>
      <Divider />
      <EditorButton onClick={() => editor.chain().focus().setHorizontalRule().run()} title="Horizontal Rule">
        <Minus size={16} />
      </EditorButton>
      <Divider />
      <TextAlignOptions editor={editor} />
    </div>
  );
};

export default Toolbar;
